import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ATMIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M20 4H4V10H6V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V10H20V4ZM9.19995 7.8H7.8V18C7.8 18.1105 7.88954 18.2 8 18.2H9.19995V7.8ZM11.7 7.8V18.2H16C16.1105 18.2 16.2 18.1105 16.2 18V7.8H11.7Z"
      />
    </SvgIcon>
  );
});
